import React from 'react';
import BlockChart from '../../BlockChart';
import { useGetPublisherConsentsQuery } from '../../../api/publisherApiSlice';
import StackedPercentageBarChart from '../../charts/StackedPercentageBarChart'
import { useTranslation } from 'react-i18next';
import vendorConsentByOsTransformer from '../../../services/data/charts/vendorConsentByOsTransformer';

export default function VendorConsentByOs ( { publisherId, startDate, endDate } ) {
  const { t } = useTranslation();
  const defaultData = {"categories":["ios","android"],"series":[{"name":"yes","data":[0,0]},{"name":"no","data":[0,0]}]}
  const { data = [], isSuccess, isLoading } = useGetPublisherConsentsQuery({publisherId, startDate, endDate})
  const chartData = vendorConsentByOsTransformer(data, defaultData)

  return (
    <BlockChart title={t("publisher.vendorConsentByOs")} isSuccess={isSuccess} isLoading={isLoading}>
      <StackedPercentageBarChart data={chartData}/>
    </BlockChart>
  )
}
